import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "antd";
import { LoginOutlined, LogoutOutlined } from '@ant-design/icons';

export const Login = () => {

  function LoginButton() {
    const { instance } = useMsal();
  
    const handleLogin = () => {
      instance.loginRedirect();
    };
  
    return (
      <Button
        icon={<LoginOutlined />}
        className="signInButton"
        onClick={handleLogin}
      >
        Login with Microsoft
      </Button>
    );
  }

  function LogoutButton() {
    const { instance } = useMsal();
  
    const handleLogout = () => {
      instance.logoutRedirect({ postLogoutRedirectUri: "/" }); // Optional: Redirect after logout
    };
  
    return (
      <Button
        icon={<LogoutOutlined />}
        className="signOutButton"
        onClick={handleLogout}
      >
        Logout
      </Button>
    );
  }

  return (
    <div className="login-container">
      <LoginButton />
      <LogoutButton />
    </div>
  );
};
